export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
}

export enum MouseMask {
  None = 0,
  Primary = 1,
  Secondary = 2,
  Auxiliary = 4,
  Back = 8,
  Forward = 16,
}
